module.exports = __webpack_public_path__ + "img/solid_box000.0b9e4ddd.png";